import { apiGetBannerList, RespBanners } from '@vas2t-lowcode/api';
import type { AxiosPromise } from 'axios';

let bannerTopReq = undefined as undefined | AxiosPromise<RespBanners>;

/**
 * 获取预加载的数据
 *
 * @returns
 */
export const reqBannerTopDataAsync = () => {
  if (!bannerTopReq) {
    bannerTopReq = window._reqBannerTopAsync || apiGetBannerList();
    return bannerTopReq;
  }

  return bannerTopReq;
};

/**
 * 重置预加载的数据, 防止下次reqBannerTopDataAsync获取的为旧数据
 *
 * @returns
 */
export const resetBannerTopDataAsync = () => {
  bannerTopReq = undefined;
  window._reqBannerTopAsync = undefined;
};
